"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var ProgressBar_styled_exports = {};
__export(ProgressBar_styled_exports, {
  Bar: () => Bar,
  Container: () => Container
});
module.exports = __toCommonJS(ProgressBar_styled_exports);
var import_styled_components = __toESM(require("styled-components"));
var Container = import_styled_components.default.div.withConfig({
  displayName: "ProgressBarstyled__Container",
  componentId: "sc-1a8hwj3-0"
})(function(_ref) {
  var theme = _ref.theme;
  return (0, import_styled_components.css)(["background-color:", ";display:block;height:4px;overflow:hidden;position:relative;width:100%;"], theme.colors.transparent.black);
});
var Bar = import_styled_components.default.div.withConfig({
  displayName: "ProgressBarstyled__Bar",
  componentId: "sc-1a8hwj3-1"
})(function(_ref2) {
  var theme = _ref2.theme, _ref2$variant = _ref2.variant, variant = _ref2$variant === void 0 ? "indeterminate" : _ref2$variant, _ref2$value = _ref2.value, value = _ref2$value === void 0 ? null : _ref2$value;
  var indeterminateBefore = function indeterminateBefore2() {
    return (0, import_styled_components.css)(["animation:indeterminate 2.1s cubic-bezier(0.65,0.815,0.735,0.395) infinite;"]);
  };
  var indeterminateAfter = function indeterminateAfter2() {
    return (0, import_styled_components.css)(["animation:indeterminate-short 2.1s cubic-bezier(0.165,0.84,0.44,1) infinite;animation-delay:1.15s;"]);
  };
  return (0, import_styled_components.css)(["background-color:", ";&:before{content:'';position:absolute;background-color:inherit;top:0;left:0;bottom:0;will-change:left,right;", "}&:after{content:'';position:absolute;background-color:inherit;top:0;left:0;bottom:0;will-change:left,right;", "}@keyframes indeterminate{0%{left:-35%;right:100%;}60%{left:100%;right:-90%;}100%{left:100%;right:-90%;}}@keyframes indeterminate-short{0%{left:-200%;right:100%;}60%{left:107%;right:-8%;}100%{left:107%;right:-8%;}}"], theme.colors.primary.base, variant === "indeterminate" ? indeterminateBefore() : "width: ".concat(value, "%;"), variant === "indeterminate" ? indeterminateAfter() : "width: ".concat(value, "%;"));
});
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  Bar,
  Container
});
//# sourceMappingURL=ProgressBar.styled.js.map